import React from 'react';
import PropTypes from 'prop-types';

const SrRenterApplicationStatusInviteRoommateRowSunroom = ({
  onInviteRoommateClicked,
  listing,
  householdId,
}) => (
  <div
    className="SrRenterApplicationStatusInviteRoommateRowSunroom"
    onClick={() => onInviteRoommateClicked({ listing, householdId })}
  >
    <div className="actionContainer">
      <span
        className="actionLink"
        onClick={() => onInviteRoommateClicked({ listing, householdId })}
      />
    </div>
    <div className="textContainer">
      <span className="addRoommate">Add Applicants</span>
      <span className="addRoommateMessage">Send a link to apply</span>
    </div>
  </div>
);

SrRenterApplicationStatusInviteRoommateRowSunroom.propTypes = {
  onInviteRoommateClicked: PropTypes.func.isRequired,
  listing: PropTypes.object.isRequired,
};

SrRenterApplicationStatusInviteRoommateRowSunroom.displayName =
  'SrRenterApplicationStatusInviteRoommateRowSunroom';

export default SrRenterApplicationStatusInviteRoommateRowSunroom;
